// src/themes.js
export const themes = {
  glass: {
    name: 'Glass',
    className: 'bg-white/20 backdrop-blur-md text-white rounded-3xl shadow-lg',
    colors: {
      background:
        'bg-[linear-gradient(to_bottom,_#1D4ED8,_#1E40AF,_#1E3A8A)] dark:bg-[linear-gradient(to_bottom,_#0C1023,_#151A2C,_#1E263A)]',
      text: 'text-white',
      button: 'bg-white/10 text-white hover:bg-white/20 border border-white/30',
    },
  },
  colorBlind: {
    name: 'Color Blind',
    className:
      'bg-neutral-100 dark:bg-neutral-800 text-gray-900 dark:text-gray-100 rounded-3xl shadow-md',
    colors: {
      background: 'bg-neutral-100 dark:bg-neutral-800',
      text: 'text-gray-900 dark:text-gray-100',
      button:
        'bg-neutral-300 dark:bg-neutral-700 text-gray-900 dark:text-gray-100 hover:bg-neutral-400',
    },
  },
  retro: {
    name: 'Retro',
    className:
      'bg-[#F7E9A0] text-[#2B1C07] border-4 border-[#2B1C07] rounded-none shadow-lg',
    colors: {
      background: 'bg-[#F7E9A0]',
      text: 'text-[#2B1C07]',
      button:
        'bg-[#FF7F11] text-white hover:bg-[#E06B00] border-2 border-[#2B1C07]',
    },
  },
};
